var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_240",
    "data-name": "Group 240",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.037,
    height: 71.037,
    viewBox: "0 0 71.037 71.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M48,80H59.458V91.458H48Zm0,0",
    transform: "translate(-41.125 -68.542)",
    fill: "#57a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M48,208H59.458v11.458H48Zm0,0",
    transform: "translate(-41.125 -178.21)",
    fill: "#57a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M48,336H59.458v11.458H48Zm0,0",
    transform: "translate(-41.125 -287.878)",
    fill: "#57a4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M67.6,0H3.437A3.437,3.437,0,0,0,0,3.437V67.6a3.437,3.437,0,0,0,3.437,3.437H67.6A3.437,3.437,0,0,0,71.037,67.6V3.437A3.437,3.437,0,0,0,67.6,0Zm1.146,67.6A1.146,1.146,0,0,1,67.6,68.745H3.437A1.146,1.146,0,0,1,2.292,67.6V3.437A1.146,1.146,0,0,1,3.437,2.292H67.6a1.146,1.146,0,0,1,1.146,1.146Zm0,0",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M52.6,72H41.146A1.146,1.146,0,0,0,40,73.146V84.6a1.146,1.146,0,0,0,1.146,1.146H52.6A1.146,1.146,0,0,0,53.749,84.6V73.146A1.146,1.146,0,0,0,52.6,72ZM51.458,83.458H42.292V74.292h9.166Zm0,0",
    transform: "translate(-34.271 -61.688)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M194.393,80H153.146a1.146,1.146,0,1,0,0,2.292h41.247a1.146,1.146,0,1,0,0-2.292Zm0,0",
    transform: "translate(-130.231 -68.542)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M194.393,112H153.146a1.146,1.146,0,1,0,0,2.292h41.247a1.146,1.146,0,1,0,0-2.292Zm0,0",
    transform: "translate(-130.231 -95.959)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M153.146,146.292H179.5a1.146,1.146,0,0,0,0-2.292H153.146a1.146,1.146,0,0,0,0,2.292Zm0,0",
    transform: "translate(-130.231 -123.376)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M362.292,146.292a1.146,1.146,0,0,0,0-2.292h-1.146a1.146,1.146,0,0,0,0,2.292Zm0,0",
    transform: "translate(-308.441 -123.376)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M52.6,200H41.146A1.146,1.146,0,0,0,40,201.146V212.6a1.146,1.146,0,0,0,1.146,1.146H52.6a1.146,1.146,0,0,0,1.146-1.146V201.146A1.146,1.146,0,0,0,52.6,200Zm-1.146,11.458H42.292v-9.166h9.166Zm0,0",
    transform: "translate(-34.271 -171.356)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M194.393,208H153.146a1.146,1.146,0,0,0,0,2.292h41.247a1.146,1.146,0,1,0,0-2.292Zm0,0",
    transform: "translate(-130.231 -178.21)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M194.393,240H153.146a1.146,1.146,0,1,0,0,2.292h41.247a1.146,1.146,0,1,0,0-2.292Zm0,0",
    transform: "translate(-130.231 -205.627)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M153.146,274.292H179.5a1.146,1.146,0,0,0,0-2.292H153.146a1.146,1.146,0,1,0,0,2.292Zm0,0",
    transform: "translate(-130.231 -233.044)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M362.292,274.292a1.146,1.146,0,0,0,0-2.292h-1.146a1.146,1.146,0,0,0,0,2.292Zm0,0",
    transform: "translate(-308.441 -233.044)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M52.6,328H41.146A1.146,1.146,0,0,0,40,329.146V340.6a1.146,1.146,0,0,0,1.146,1.146H52.6a1.146,1.146,0,0,0,1.146-1.146V329.146A1.146,1.146,0,0,0,52.6,328Zm-1.146,11.457H42.292v-9.166h9.166Zm0,0",
    transform: "translate(-34.271 -281.024)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M194.393,336H153.146a1.146,1.146,0,1,0,0,2.291h41.247a1.146,1.146,0,1,0,0-2.291Zm0,0",
    transform: "translate(-130.231 -287.878)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M194.393,368H153.146a1.146,1.146,0,1,0,0,2.291h41.247a1.146,1.146,0,1,0,0-2.291Zm0,0",
    transform: "translate(-130.231 -315.295)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M179.5,400H153.146a1.146,1.146,0,1,0,0,2.292H179.5a1.146,1.146,0,0,0,0-2.292Zm0,0",
    transform: "translate(-130.231 -342.712)",
    fill: "#002173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M362.292,400h-1.146a1.146,1.146,0,1,0,0,2.292h1.146a1.146,1.146,0,1,0,0-2.292Zm0,0",
    transform: "translate(-308.441 -342.712)",
    fill: "#002173"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.da7c600cdb319c9a94874f14dce345c0.svg";
export { ForwardRef as ReactComponent };